import React from 'react';
import { connect } from 'react-redux';
import { camViewChange, setSingleView, setCameraBrowserCam, setCamGroupSingle, setCamGroupQuad } from '../actions';
import { FaChevronCircleRight, FaChevronCircleLeft } from 'react-icons/fa';
import '../App.css';

class CamButtonsView extends React.Component {
    constructor(props) {
        super(props);

        this.state = {
            temp: ''
        }
    }

    // c[0] - string cam_x
    // cam[1] - cam number - int
    // c[2] - enabled? 
    setSingleCamData = cam => {
        this.props.camViewChange(cam[0]);  
        this.props.setCameraBrowserCam(cam[1]);
    }

    setMultipleCamData = cam => {
        this.props.singleCamSelected && this.props.setSingleView(''); 
        this.props.camViewChange(cam);
    }

    incrementCamGroupSingle = () => {
        this.props.setCamGroupSingle('inc');
        // setting cam view is pre-increment
        switch (this.props.currentCamGroupSingle) {
            case 1:
                this.props.camViewChange('cam_17');
                break;
            case 2:
                this.props.camViewChange('cam_33');
                break;
            case 3:
                this.props.camViewChange('cam_49');
                break;
            default:
                this.props.camViewChange('cam_17')   
        }
    }

    decrementCamGroupSingle = () => {
        this.props.setCamGroupSingle('dec');
        // setting cam view is pre-decrement
        switch (this.props.currentCamGroupSingle) {
            case 4:
                this.props.camViewChange('cam_33');
                break;
            case 3:
                this.props.camViewChange('cam_17');
                break;
            case 2:
                this.props.camViewChange('cam_1');
                break;
            default:
                this.props.camViewChange('cam_11')   
        }
    }

    incrementCamGroupQuad = () => {
        this.props.setCamGroupQuad('inc');
        this.props.camViewChange('cam_33-36');
    }

    decrementCamGroupQuad = () => {
        this.props.setCamGroupQuad('dec');
        this.props.camViewChange('cam_1-4');
    }


    render() {
  
        const singleView = <div>
                            { this.props.cameras.length > 16 && this.props.currentCamGroupSingle > 1 ?
                                <FaChevronCircleLeft style={{ height: '3vmin', width: '3vmin', marginBottom: '.3vmin', color: 'lightgrey', opacity: 0.5 }} onClick={() => this.decrementCamGroupSingle() } /> :
                                null
                            }

                            { this.props.bNumcams < 17 ?
                                this.props.cameraArr.map(c => 
                                    <button key={c[1]}
                                            style={{ color: !c[2] || this.props.userCameras.indexOf(parseInt(c[1])) < 0 ? 'rgba(0,0,0,0.4)' : this.props.currentCamView === c[0] ? 'white' : 'black', 
                                            backgroundColor: !c[2] || this.props.userCameras.indexOf(parseInt(c[1])) < 0 ? 'white' : this.props.currentCamView === c[0] ? 'dodgerblue' : 'lightgrey', 
                                            fontSize: '1.5vmin',
                                            margin: '.8vmin', 
                                            paddingRight: 8, 
                                            paddingLeft: 8, 
                                            paddingTop: 3, 
                                            paddingBottom: 3, 
                                            border: !c[2] ? '2px solid lightgrey' : this.props.currentCamView === c[0] ? '2px solid dodgerblue' : '2px solid lightgrey', 
                                            borderRadius: 5, 
                                            }} 
                                            className={ c[2] && this.props.userCameras.indexOf(parseInt(c[1])) > -1 ?  "hoverableButton" : null }
                                            onClick={ () => c[2] && this.props.userCameras.indexOf(parseInt(c[1])) > -1 ? this.setSingleCamData(c) : null }>
                                        { c[1] }
                                    </button>
                                ) :
                              this.props.currentCamGroupSingle === 1 ?
                                this.props.cameraArr.slice(0,16).map(c => 
                                    <button key={c[1]}
                                            style={{ color: !c[2] || this.props.userCameras.indexOf(parseInt(c[1])) < 0 ? 'rgba(0,0,0,0.4)' : this.props.currentCamView === c[0] ? 'white' : 'black', 
                                            backgroundColor: !c[2] || this.props.userCameras.indexOf(parseInt(c[1])) < 0 ? 'white' : this.props.currentCamView === c[0] ? 'dodgerblue' : 'lightgrey', 
                                            fontSize: '1.5vmin',
                                            margin: '.8vmin', 
                                            paddingRight: 8, 
                                            paddingLeft: 8, 
                                            paddingTop: 3, 
                                            paddingBottom: 3, 
                                            border: !c[2] ? '2px solid lightgrey' : this.props.currentCamView === c[0] ? '2px solid dodgerblue' : '2px solid lightgrey', 
                                            borderRadius: 5, 
                                            }} 
                                            className={ c[2] && this.props.userCameras.indexOf(parseInt(c[1])) > -1 ?  "hoverableButton" : null }
                                            onClick={ () => c[2] && this.props.userCameras.indexOf(parseInt(c[1])) > -1 ? this.setSingleCamData(c) : null }>
                                        { c[1] }
                                    </button>
                                ) :
                              this.props.currentCamGroupSingle === 2 ?
                                this.props.cameraArr.slice(16,32).map(c => 
                                    <button key={c[1]}
                                            style={{ color: !c[2] || this.props.userCameras.indexOf(parseInt(c[1])) < 0 ? 'rgba(0,0,0,0.4)' : this.props.currentCamView === c[0] ? 'white' : 'black', 
                                            backgroundColor: !c[2] || this.props.userCameras.indexOf(parseInt(c[1])) < 0 ? 'white' : this.props.currentCamView === c[0] ? 'dodgerblue' : 'lightgrey', 
                                            fontSize: '1.5vmin',
                                            margin: '.8vmin', 
                                            paddingRight: 8, 
                                            paddingLeft: 8, 
                                            paddingTop: 3, 
                                            paddingBottom: 3, 
                                            border: !c[2] ? '2px solid lightgrey' : this.props.currentCamView === c[0] ? '2px solid dodgerblue' : '2px solid lightgrey', 
                                            borderRadius: 5, 
                                            }} 
                                            className={ c[2] && this.props.userCameras.indexOf(parseInt(c[1])) > -1 ?  "hoverableButton" : null }
                                            onClick={ () => c[2] && this.props.userCameras.indexOf(parseInt(c[1])) > -1 ? this.setSingleCamData(c) : null }>
                                        { c[1] }
                                    </button>
                                ) :
                              this.props.currentCamGroupSingle  === 3 && this.props.bNumCams > 32 ?
                                this.props.cameraArr.slice(32,48).map(c => 
                                    <button key={c[1]}
                                            style={{ color: !c[2] || this.props.userCameras.indexOf(parseInt(c[1])) < 0 ? 'rgba(0,0,0,0.4)' : this.props.currentCamView === c[0] ? 'white' : 'black', 
                                            backgroundColor: !c[2] || this.props.userCameras.indexOf(parseInt(c[1])) < 0 ? 'white' : this.props.currentCamView === c[0] ? 'dodgerblue' : 'lightgrey', 
                                            fontSize: '1.5vmin',
                                            margin: '.8vmin', 
                                            paddingRight: 8, 
                                            paddingLeft: 8, 
                                            paddingTop: 3, 
                                            paddingBottom: 3, 
                                            border: !c[2] ? '2px solid lightgrey' : this.props.currentCamView === c[0] ? '2px solid dodgerblue' : '2px solid lightgrey', 
                                            borderRadius: 5, 
                                            }} 
                                            className={ c[2] && this.props.userCameras.indexOf(parseInt(c[1])) > -1 ?  "hoverableButton" : null }
                                            onClick={ () => c[2] && this.props.userCameras.indexOf(parseInt(c[1])) > -1 ? this.setSingleCamData(c) : null }>
                                        { c[1] }
                                    </button>
                                ) :
                              this.props.currentCamGroupSingle  === 4 && this.props.bNumCams > 48 ?
                                this.props.cameraArr.slice(48,64).map(c => 
                                    <button key={c[1]}
                                            style={{ color: !c[2] || this.props.userCameras.indexOf(parseInt(c[1])) < 0 ? 'rgba(0,0,0,0.4)' : this.props.currentCamView === c[0] ? 'white' : 'black', 
                                            backgroundColor: !c[2] || this.props.userCameras.indexOf(parseInt(c[1])) < 0 ? 'white' : this.props.currentCamView === c[0] ? 'dodgerblue' : 'lightgrey', 
                                            fontSize: '1.5vmin',
                                            margin: '.8vmin', 
                                            paddingRight: 8, 
                                            paddingLeft: 8, 
                                            paddingTop: 3, 
                                            paddingBottom: 3, 
                                            border: !c[2] ? '2px solid lightgrey' : this.props.currentCamView === c[0] ? '2px solid dodgerblue' : '2px solid lightgrey', 
                                            borderRadius: 5, 
                                            }} 
                                            className={ c[2] && this.props.userCameras.indexOf(parseInt(c[1])) > -1 ?  "hoverableButton" : null }
                                            onClick={ () => c[2] && this.props.userCameras.indexOf(parseInt(c[1])) > -1 ? this.setSingleCamData(c) : null }>
                                        { c[1] }
                                    </button>
                                ) :
                                this.props.cameraArr.slice(0,16).map(c => 
                                    <button key={c[1]}
                                            style={{ color: !c[2] || this.props.userCameras.indexOf(parseInt(c[1])) < 0 ? 'rgba(0,0,0,0.4)' : this.props.currentCamView === c[0] ? 'white' : 'black', 
                                            backgroundColor: !c[2] || this.props.userCameras.indexOf(parseInt(c[1])) < 0 ? 'white' : this.props.currentCamView === c[0] ? 'dodgerblue' : 'lightgrey', 
                                            fontSize: '1.5vmin',
                                            margin: '.8vmin', 
                                            paddingRight: 8, 
                                            paddingLeft: 8, 
                                            paddingTop: 3, 
                                            paddingBottom: 3, 
                                            border: !c[2] ? '2px solid lightgrey' : this.props.currentCamView === c[0] ? '2px solid dodgerblue' : '2px solid lightgrey', 
                                            borderRadius: 5, 
                                            }} 
                                            className={ c[2] && this.props.userCameras.indexOf(parseInt(c[1])) > -1 ?  "hoverableButton" : null }
                                            onClick={ () => c[2] && this.props.userCameras.indexOf(parseInt(c[1])) > -1 ? this.setSingleCamData(c) : null }>
                                        { c[1] }
                                    </button>
                                )
                            }

                            { this.props.cameras.length > 16 && this.props.currentCamGroupSingle <= this.props.cameras.length / 16 ?
                                <FaChevronCircleRight style={{ height: '3vmin', width: '3vmin', marginBottom: '.3vmin', color: 'lightgrey', opacity: 0.5 }} onClick={() => this.incrementCamGroupSingle() } /> :
                                null
                            }

                            <button style={{ color: this.props.autoScanning ? 'white' : 'black', backgroundColor: this.props.autoScanning ? 'dodgerblue' : 'lightgrey', fontSize: '1.5vmin', margin: '.8vmin', paddingRight: 8, paddingLeft: 8, paddingTop: 3, paddingBottom: 3, border: 'none', borderRadius: 5, boxShadow: '2px 2px 4px 2px rgba(40,120,255,0.4), -2px -2px 4px 2px rgba(40,120,255,0.4)' }}
                                    className="hoverable"
                                    onClick={ this.props.toggleAutoScan }>
                                AS
                            </button>
                        </div>

        const quadView = <div>
                        { this.props.bNumCams > 32 && this.props.currentCamGroupQuad > 1 ?
                            <FaChevronCircleLeft style={{ height: '3vmin', width: '3vmin', marginBottom: '.3vmin', color: 'lightgrey', opacity: 0.5 }} onClick={this.decrementCamGroupQuad} /> :
                            null
                        }
                        { this.props.bNumcams < 32 ?
                            this.props.quadView.map(v => 
                                <button key={v[0]}
                                        style={{ color: !v[1] ? 'rgba(0,0,0,0.4)' : this.props.currentCamView === "cam_" + v[0] ? 'white' : 'black', 
                                                backgroundColor: !v[1] ? 'white' : this.props.currentCamView === "cam_" + v[0] ? 'dodgerblue' : 'lightgrey', 
                                                fontSize: '1.5vmin', 
                                                margin: '.8vmin', 
                                                paddingRight: 8, 
                                                paddingLeft: 8, 
                                                paddingTop: 3, 
                                                paddingBottom: 3, 
                                                border: 'none', 
                                                borderRadius: 5
                                                }}
                                        className="hoverable"
                                        onClick={ () => v[1] ? this.setMultipleCamData ('cam_' + v[0]) : null }>
                                    {v[0].split('-')[0] + ' - ' + v[0].split('-')[1]}
                                </button>
                            ) :
                            this.props.currentCamGroupQuad === 1 ?
                                this.props.quadView.slice(0,8).map(v => 
                                        <button key={v[0]}
                                                style={{ color: !v[1] ? 'rgba(0,0,0,0.4)' : this.props.currentCamView === "cam_" + v[0] ? 'white' : 'black', 
                                                        backgroundColor: !v[1] ? 'white' : this.props.currentCamView === "cam_" + v[0] ? 'dodgerblue' : 'lightgrey', 
                                                        fontSize: '1.5vmin', 
                                                        margin: '.8vmin', 
                                                        paddingRight: 8, 
                                                        paddingLeft: 8, 
                                                        paddingTop: 3, 
                                                        paddingBottom: 3, 
                                                        border: 'none', 
                                                        borderRadius: 5
                                                        }}
                                                className="hoverable"
                                                onClick={ () => v[1] ? this.setMultipleCamData ('cam_' + v[0]) : null }>
                                            {v[0].split('-')[0] + ' - ' + v[0].split('-')[1]}
                                        </button>
                                    ) :
                                this.props.currentCamGroupQuad === 2 ?
                                    this.props.quadView.slice(8, 16).map(v => 
                                        <button key={v[0]}
                                                style={{ color: !v[1] ? 'rgba(0,0,0,0.4)' : this.props.currentCamView === "cam_" + v[0] ? 'white' : 'black', 
                                                        backgroundColor: !v[1] ? 'white' : this.props.currentCamView === "cam_" + v[0] ? 'dodgerblue' : 'lightgrey', 
                                                        fontSize: '1.5vmin', 
                                                        margin: '.8vmin', 
                                                        paddingRight: 8, 
                                                        paddingLeft: 8, 
                                                        paddingTop: 3, 
                                                        paddingBottom: 3, 
                                                        border: 'none', 
                                                        borderRadius: 5
                                                        }}
                                                className="hoverable"
                                                onClick={ () => v[1] ? this.setMultipleCamData ('cam_' + v[0]) : null }>
                                            {v[0].split('-')[0] + ' - ' + v[0].split('-')[1]}
                                        </button>
                                    ) :
                                    this.props.quadView.map(v => 
                                        <button key={v[0]}
                                                style={{ color: !v[1] ? 'rgba(0,0,0,0.4)' : this.props.currentCamView === "cam_" + v[0] ? 'white' : 'black', 
                                                        backgroundColor: !v[1] ? 'white' : this.props.currentCamView === "cam_" + v[0] ? 'dodgerblue' : 'lightgrey', 
                                                        fontSize: '1.5vmin', 
                                                        margin: '.8vmin', 
                                                        paddingRight: 8, 
                                                        paddingLeft: 8, 
                                                        paddingTop: 3, 
                                                        paddingBottom: 3, 
                                                        border: 'none', 
                                                        borderRadius: 5
                                                        }}
                                                className="hoverable"
                                                onClick={ () => v[1] ? this.setMultipleCamData ('cam_' + v[0]) : null }>
                                            {v[0].split('-')[0] + ' - ' + v[0].split('-')[1]}
                                        </button>
                                    )
                            }

                        { this.props.bNumCams > 32 && this.props.currentCamGroupQuad < 2 ?
                            <FaChevronCircleRight style={{ height: '3vmin', width: '3vmin', marginBottom: '.3vmin', color: 'lightgrey', opacity: 0.5 }} onClick={this.incrementCamGroupQuad} /> :
                            null
                        }

                        <button style={{ color: this.props.autoScanning ? 'white' : 'black', 
                                         backgroundColor: this.props.autoScanning ? 'dodgerblue' : 'lightgrey', 
                                         fontSize: '1.5vmin', 
                                         margin: '.8vmin', 
                                         paddingRight: 8, 
                                         paddingLeft: 8, 
                                         paddingTop: 3, 
                                         paddingBottom: 3, 
                                         border: 'none', 
                                         borderRadius: 5
                                        }}
                                className="hoverable"
                                onClick={ this.props.toggleAutoScan }>
                            AS
                        </button>
                    </div>

        const sixView = <div>
                        { this.props.sixView.map(v => 
                            <button key={v[0]}
                                    style={{ color: !v[1] ? 'rgba(0,0,0,0.4)' : this.props.currentCamView === "cam_" + v[0] ? 'white' : 'black', 
                                             backgroundColor: !v[1] ? 'white' : this.props.currentCamView === "cam_" + v[0] ? 'dodgerblue' : 'lightgrey', 
                                             fontSize: '1.5vmin', 
                                             margin: '.8vmin', 
                                             paddingRight: 8, 
                                             paddingLeft: 8, 
                                             paddingTop: 3, 
                                             paddingBottom: 3, 
                                             border: 'none', 
                                             borderRadius: 5
                                            }}
                                    className="hoverable"
                                    onClick={ () => v[1] ? this.setMultipleCamData ('cam_' + v[0]) : null }>
                                {v[0].split('-')[0] + ' - ' + v[0].split('-')[1]}
                            </button>
                        )}
                        <button style={{ color: this.props.autoScanning ? 'white' : 'black', 
                                         backgroundColor: this.props.autoScanning ? 'dodgerblue' : 'lightgrey', 
                                         fontSize: '1.5vmin', 
                                         margin: '.8vmin', 
                                         paddingRight: 8, 
                                         paddingLeft: 8, 
                                         paddingTop: 3, 
                                         paddingBottom: 3, 
                                         border: 'none', 
                                         borderRadius: 5
                                        }}
                                className="hoverable"
                                onClick={ this.props.toggleAutoScan }>
                            AS
                        </button>
                    </div>

        const nineView = <div>
                        { this.props.nineView.map(v => 
                            <button key={v[0]}
                                    style={{ color: !v[1] ? 'rgba(0,0,0,0.4)' : this.props.currentCamView === "cam_" + v[0] ? 'white' : 'black', 
                                             backgroundColor: !v[1] ? 'white' : this.props.currentCamView === "cam_" + v[0] ? 'dodgerblue' : 'lightgrey', 
                                             fontSize: '1.5vmin', 
                                             margin: '.8vmin', 
                                             paddingRight: 8, 
                                             paddingLeft: 8, 
                                             paddingTop: 3, 
                                             paddingBottom: 3, 
                                             border: 'none', 
                                             borderRadius: 5
                                            }}
                                    className="hoverable"
                                    onClick={ () => v[1] ? this.setMultipleCamData ('cam_' + v[0]) : null }>
                                {v[0].split('-')[0] + ' - ' + v[0].split('-')[1]}
                            </button>
                        )}
                        <button style={{ color: this.props.autoScanning ? 'white' : 'black', 
                                         backgroundColor: this.props.autoScanning ? 'dodgerblue' : 'lightgrey', 
                                         fontSize: '1.5vmin', 
                                         margin: '.8vmin', 
                                         paddingRight: 8, 
                                         paddingLeft: 8, 
                                         paddingTop: 3, 
                                         paddingBottom: 3, 
                                         border: 'none', 
                                         borderRadius: 5
                                        }}
                                className="hoverable"
                                onClick={ this.props.toggleAutoScan }>
                            AS
                        </button>
                    </div>

        const twelveView = <div>
                        { this.props.twelveView.map(v => 
                            <button key={v[0]}
                                    style={{ color: !v[1] ? 'rgba(0,0,0,0.4)' : this.props.currentCamView === "cam_" + v[0] ? 'white' : 'black', 
                                             backgroundColor: !v[1] ? 'white' : this.props.currentCamView === "cam_" + v[0] ? 'dodgerblue' : 'lightgrey', 
                                             fontSize: '1.5vmin', 
                                             margin: '.8vmin', 
                                             paddingRight: 8, 
                                             paddingLeft: 8, 
                                             paddingTop: 3, 
                                             paddingBottom: 3, 
                                             border: 'none', 
                                             borderRadius: 5
                                             }}
                                    className="hoverable"
                                    onClick={ () => v[1] ? this.setMultipleCamData ('cam_' + v[0]) : null }>
                                {v[0].split('-')[0] + ' - ' + v[0].split('-')[1]}
                            </button>
                        )}
                        <button style={{ color: this.props.autoScanning ? 'white' : 'black', 
                                         backgroundColor: this.props.autoScanning ? 'dodgerblue' : 'lightgrey', 
                                         fontSize: '1.5vmin',
                                          margin: '.8vmin', 
                                          paddingRight: 8, 
                                          paddingLeft: 8, 
                                          paddingTop: 3, 
                                          paddingBottom: 3, 
                                          border: 'none', 
                                          borderRadius: 5
                                        }}
                                className="hoverable"
                                onClick={ this.props.toggleAutoScan }>
                            AS
                        </button>
                     </div>

        const sixteenView = <div>
                            { this.props.sixteenView.map(v => 
                                <button key={v[0]}
                                        style={{ color: !v[1] ? 'rgba(0,0,0,0.4)' : this.props.currentCamView === "cam_" + v[0] ? 'white' : 'black', 
                                                 backgroundColor: !v[1] ? 'white' : this.props.currentCamView === "cam_" + v[0] ? 'dodgerblue' : 'lightgrey', 
                                                 fontSize: '1.5vmin', 
                                                 margin: '.8vmin', 
                                                 paddingRight: 8, 
                                                 paddingLeft: 8, 
                                                 paddingTop: 3, 
                                                 paddingBottom: 3, 
                                                 border: 'none', 
                                                 borderRadius: 5
                                                }}
                                        className="hoverable"
                                        onClick={ () => v[1] ? this.setMultipleCamData('cam_' + v[0]) : null }>
                                    {v[0].split('-')[0] + ' - ' + v[0].split('-')[1]}
                                </button>
                            )}
                            <button style={{ color: this.props.autoScanning ? 'white' : 'black', 
                                             backgroundColor: this.props.autoScanning ? 'dodgerblue' : 'lightgrey', 
                                             fontSize: '1.5vmin', 
                                             margin: '.8vmin', 
                                             paddingRight: 8, 
                                             paddingLeft: 8, 
                                             paddingTop: 3, 
                                             paddingBottom: 3, 
                                             border: 'none', 
                                             borderRadius: 5
                                            }}
                                    className="hoverable"
                                    onClick={ this.props.toggleAutoScan }>
                                AS
                            </button>
                        </div>
        return (
            <div>
                <div>
                    { this.props.conf === "conf-1" && singleView }
                    { this.props.conf === "conf-4" && quadView }
                    { this.props.conf === "conf-6" && sixView }
                    { this.props.conf === "conf-9" && nineView }
                    { this.props.conf === "conf-12" && twelveView }
                    { this.props.conf === "conf-16" && sixteenView }
                </div> 
            </div>
        )
    }
}

const mapStateToProps = state => {
    const { conf } = state.config;
    const { 
        bAutoScanTimeout, 
        bNumCams, 
        cameras, 
        cameraArr, 
        singleViewEnabledArr, 
        quadView, 
        quadViewEnabledArr, 
        sixView, 
        sixViewEnabledArr, 
        nineView, 
        nineViewEnabledArr, 
        twelveView, 
        twelveViewEnabledArr, 
        sixteenView,
        sixteenViewEnabledArr
     } = state.server;
    const { currentCamView, currentCamGroupSingle, autoScrollEnabled } = state.camera;
    const { singleCamSelected } = state.video;
    const { userCameras } = state.user;
    return {
        conf,
        currentCamView,
        currentCamGroupSingle,
        autoScrollEnabled,
        bAutoScanTimeout,
        bNumCams,
        cameras,
        cameraArr, 
        singleViewEnabledArr,
        quadView, 
        quadViewEnabledArr, 
        sixView, 
        sixViewEnabledArr, 
        nineView, 
        nineViewEnabledArr, 
        twelveView, 
        twelveViewEnabledArr, 
        sixteenView,
        sixteenViewEnabledArr,
        singleCamSelected,
        userCameras
    }
}

export default connect(mapStateToProps, { camViewChange, setSingleView, setCameraBrowserCam, setCamGroupSingle, setCamGroupQuad })(CamButtonsView);